import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';
import { mapPedidoSearch } from '@/libs/pedidoSearch';

export default class PTC_Pedidos {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async retornaPedidos(queries = null) {
    const query = `ptc/retornapedido?${this.buildParams(queries)}`;

    try {
      const result = await this.api.get(query);
      return result.data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao retornar Pedidos');
    }
  }

  buildParams(queries = null) {
    queries = mapPedidoSearch(queries, 'nrPedido_PW', 'nrPedido_ERP');
    const params = [];

    // if (queries === undefined || queries === null || queries === '') {
    //     query = `ptc/retornapedido?`
    // }

    if (queries && queries.nrPedido_PW) {
      params.push(`nrPedido_PW=${queries.nrPedido_PW}`);
    }

    if (queries && queries.nrPedido_ERP) {
      params.push(`nrPedido_ERP=${encodeURIComponent(queries.nrPedido_ERP)}`);
    }

    if (queries && queries.codClienteERP) {
      params.push(`codClienteERP=${queries.codClienteERP}`);
    }

    if (queries && queries.razaoSocialCliente) {
      params.push(`razaoSocialCliente=${encodeURIComponent(queries.razaoSocialCliente)}`);
    }

    if (queries && queries.nomeTipoPedido) {
      params.push(`nomeTipoPedido=${queries.nomeTipoPedido}`);
    }

    if (queries && (queries.DataEmissaoDe || queries.DataEmissaoAte)) {
      params.push(`DataEmissaoDe=${queries.DataEmissaoDe}`);
      params.push(`DataEmissaoAte=${queries.DataEmissaoAte}`);
    }

    if (queries && queries.dataEntrega) {
      params.push(`dataEntrega=${queries.dataEntrega}`);
    }

    if (queries && queries.pedidoSituacao) {
      params.push(`pedidoSituacao=${queries.pedidoSituacao}`);
    }

    // Explicit whitelist: both flags use the existing authorized list endpoint.
    ['somenteBackorders', 'contagemBackorders'].forEach(flag => {
      if (queries && (queries[flag] === true || queries[flag] === 'true' || queries[flag] === 1 || queries[flag] === '1')) {
        params.push(`${flag}=true`);
      }
    });

    return params.join('&');
  }

  async exportarPedidos(queries = null) {
    try {
      const result = await this.api.get(`ptc/retornapedido/exportar?${this.buildParams(queries)}`, {
        responseType: 'blob',
      });
      return result.data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao exportar Pedidos');
    }
  }

  async retornaNotaFiscal(queries = null) {
    const query = '';

    try {
      const result = await this.api.get(query);
      return result.data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao retornar Pedidos');
    }
  }

  async retornaPedidoDetalhe(pedidoid) {
    try {
      const result = await this.api.get(`ptc/retornapedidodetalhe/${pedidoid}`);
      return result.data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao retornar Pedido Detalhe');
    }
  }
}
